<template>
  <div class="text-center">
    <v-navigation-drawer
      v-model="drawer"
      absolute
      bottom
      right
      style="box-shadow: 0 0 0 0, 0 0 0 0 , 0 0 0 0;"
      temporary
    >
    </v-navigation-drawer>
  </div>
</template>

<script>
import eventBus from "@/main";

export default {
  name: "OpenModalTransaction",
  data: () => ({
    dialog: false,
    drawer: false
  }),
  created() {
    const self = this;
    eventBus.$on("openModalTransaction", function(value) {
      self.dialog = value.dialog;
      self.drawer = value.drawer;
    });
  }
};
</script>

<style scoped></style>
